"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FooterContainer = exports.Footer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.Footer = styled_components_1.default.footer `
	padding: 56px 0;
	background: ${(p) => p.theme.palette.background.default};
	color: ${(p) => p.theme.palette.text.primary};
	text-rendering: optimizelegibility;
	font-feature-settings: "kern";
	-webkit-font-smoothing: subpixel-antialiased;

	* {
		box-sizing: border-box;
		&:focus {
			outline-style: groove;
			outline-color: ${(p) => p.theme.palette.text.secondary || p.theme.palette.text.primary};
			outline-offset: -2px;
		}
	}

	a {
		color: ${(p) => p.theme.palette.text.primary};
		text-decoration: none;
		transition: color 0.3s ${(p) => p.theme.easing};
		&:hover {
			color: ${(p) => p.theme.palette.accent.text};
			text-decoration: none;
		}
	}

	${(p) => p.theme.breakpoints.down("sm")} {
		padding: 40px 0;
	}
`;
exports.FooterContainer = styled_components_1.default.div `
	margin: 0px auto;
	width: 100%;
	display: block;
	box-sizing: border-box;
	max-width: 100%;
	padding: 0px;

	${(p) => p.theme.breakpoints.up("xs")} {
		padding-left: 16px;
		padding-right: 16px;
	}

	${(p) => p.theme.breakpoints.up("sm")} {
		padding-left: 24px;
		padding-right: 24px;
	}

	${(p) => p.theme.breakpoints.up("md")} {
		padding-left: 40px;
		padding-right: 40px;
	}

	${(p) => p.theme.breakpoints.up("lg")} {
		padding-left: 64px;
		padding-right: 64px;
		max-width: 1456px;
	}

	${(p) => p.theme.breakpoints.up("xl")} {
		padding-left: 16px;
		padding-right: 16px;
	}

	&.ar {
		direction: rtl;
	}
`;
//# sourceMappingURL=EpicGamesFooter.styles.js.map